import { setupAmountTermLockout } from "../amount-term-lockout";

let topCtaForm = $('.top-cta-form');
if (topCtaForm.length > 0) {
    topCtaForm.each((index, element) => {
        element = $(element);
        setupAmountTermLockout(element.find('[name=loan_amount]'), element.find('[name=loan_term]'));
    });
    topCtaForm.on('change', '[name=loan_purpose]', event => {
        let element = $(event.target);
        let formGroup = element.closest('.form-group');
        let value = element.val();
        formGroup.toggleClass('valid', value != '').toggleClass('invalid', value == '');
    });
}